import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Secondary",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_169",
		"data-name": "Group 169",
		transform: "translate(-230.544 -148.082)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_434",
				"data-name": "Path 434",
				d: "M264.774,153.153c-.1-.013-.2-.019-.307-.032a9.367,9.367,0,0,0-2.214.058,6.747,6.747,0,0,0-2.763,1.229,18.439,18.439,0,0,0-2.018,1.685.272.272,0,0,1-.2.071q-1.283-.059-2.567-.136a.331.331,0,0,0-.307.136l-1.861,2.517a.236.236,0,0,0,.007.351c.1.137.222.267.326.41a.333.333,0,0,0,.373.136c.62-.123,1.234-.241,1.855-.364a.188.188,0,0,1,.2.065c.091.117.183.234.274.345a2.85,2.85,0,0,1,1.163.26,2.734,2.734,0,0,1,1.359,1.294,3.205,3.205,0,0,1,1.319-.293,2.626,2.626,0,0,1,.875.143l.137-.859a.409.409,0,0,1,.2-.319,15.939,15.939,0,0,0,2.162-1.691A7.221,7.221,0,0,0,265,153.433.234.234,0,0,0,264.774,153.153Zm-2.384,2.771a.693.693,0,1,1,.764-.625A.689.689,0,0,1,262.39,155.924Z",
				transform: "translate(-12.46)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_435",
				"data-name": "Path 435",
				d: "M240.428,172.461a3.116,3.116,0,0,0-.457,1.451,2.134,2.134,0,0,0-2.247.8.231.231,0,0,1-.222.111,2.7,2.7,0,0,0-1.927.793,2.316,2.316,0,0,0-.653,1.548h-.046c-.248-.02-.5,0-.758-.007a1.614,1.614,0,0,1-.026-3.226.668.668,0,0,0,.562-.254,1.338,1.338,0,0,1,1.365-.455c.268.058.313-.007.333-.26a1.909,1.909,0,0,1,1.574-1.808,1.85,1.85,0,0,1,2.1,1.073A.335.335,0,0,0,240.428,172.461Z",
				transform: "translate(0 -11.317)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_436",
				"data-name": "Path 436",
				d: "M255.6,178.807c-.013.065-.027.137-.046.2a1.606,1.606,0,0,1-.4.722,1.84,1.84,0,0,1-1.321.488H242.9a2.432,2.432,0,0,1-.8-.13l-.179-.078c-.007.007-.007.007-.007,0a1.752,1.752,0,0,1-1.042-1.581,1.727,1.727,0,0,1,.485-1.229,2.152,2.152,0,0,1,1.487-.592.894.894,0,0,0,.737-.351,1.491,1.491,0,0,1,1.208-.625,1.629,1.629,0,0,1,.418.052.705.705,0,0,0,.577-.059.432.432,0,0,0,.06-.052.261.261,0,0,0,.053-.065.61.61,0,0,0,.093-.286,1.363,1.363,0,0,0,.02-.163,2.654,2.654,0,0,1,.106-.572,1.842,1.842,0,0,1,.1-.267,2.44,2.44,0,0,1,.285-.475,2.725,2.725,0,0,1,.186-.208,2.419,2.419,0,0,1,.438-.338,2.235,2.235,0,0,1,1.606-.254c.06.013.119.033.18.052a2.158,2.158,0,0,1,.292.1,2.089,2.089,0,0,1,1.068,1,.58.58,0,0,0,.863.293,2.42,2.42,0,0,1,1.692-.15c.053.02.106.039.159.065a1.593,1.593,0,0,1,.4.208,2,2,0,0,1,.538.54,1.951,1.951,0,0,1,.226.456,2.419,2.419,0,0,1,.126.989.713.713,0,0,0,.073.4.431.431,0,0,0,.113.149.777.777,0,0,0,.206.156,2.047,2.047,0,0,1,.4.28,1.941,1.941,0,0,1,.166.163,1.624,1.624,0,0,1,.133.169,1.5,1.5,0,0,1,.179.377A1.563,1.563,0,0,1,255.6,178.807Z",
				transform: "translate(-5.312 -12.454)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_437",
				"data-name": "Path 437",
				d: "M241.894,187.572a1.762,1.762,0,0,1-.555-2.81h.007a1.765,1.765,0,0,0,.548,2.81Z",
				transform: "translate(-5.262 -20.015)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_438",
				"data-name": "Path 438",
				d: "M254.51,179.6a.7.7,0,0,0,.091-.286A.617.617,0,0,1,254.51,179.6Z",
				transform: "translate(-13.903 -16.599)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_439",
				"data-name": "Path 439",
				d: "M254.775,177.858a2.341,2.341,0,0,1,.111-.572,2.691,2.691,0,0,0-.1.572,1.385,1.385,0,0,1-.02.163A1.369,1.369,0,0,0,254.775,177.858Z",
				transform: "translate(-14.062 -15.314)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_440",
				"data-name": "Path 440",
				d: "M255.374,175.717a2.158,2.158,0,0,1,.281-.475A2.447,2.447,0,0,0,255.374,175.717Z",
				transform: "translate(-14.448 -14.022)"
			})
		]
	}), /* @__PURE__ */ _jsx("rect", {
		id: "Rectangle_675",
		"data-name": "Rectangle 675",
		width: 24,
		height: 24,
		fill: "rgba(255,255,255,0)"
	})]
});
export default SvgDashboard;
